import React from 'react';

import Box from '../Box'
import Timer from '../../common/Timer';

export default function ABridTimerThreeNoVote(props) {
    return (
        <section className="container">
            <div className="row">
                <div className="col-xs-12 col-md-3">
                    <Box {...props} id="b4" type="ABridSideInfo" settings={props.settings.b4} classes="" disableVote={true} />
                </div>
                <div className="col-xs-12 col-md-3">
                    <Box {...props} id="b1" type="ABridTileSmall2" settings={props.settings.b1} classes="" secondArticleID={props.settings.b2?.articleID} thirdArticleID={props.settings.b3?.articleID} disableVote={true} />
                </div>
                <div className="col-xs-12 col-md-3">
                    <Box {...props} id="b2" type="ABridTileSmall2" settings={props.settings.b2} classes="" secondArticleID={props.settings.b1?.articleID} thirdArticleID={props.settings.b3?.articleID} disableVote={true} />
                </div>
                <div className="col-xs-12 col-md-3">
                    <Box {...props} id="b3" type="ABridTileSmall2" settings={props.settings.b3} classes="" secondArticleID={props.settings.b1?.articleID} thirdArticleID={props.settings.b2?.articleID} disableVote={true} />
                </div>
            </div>
        </section>
    );
}